export const environment = {
  production: false,
  apiUrl: 'https://1b5lrixz4b.execute-api.us-east-1.amazonaws.com',
  adminUrl: 'http://localhost:4201',
  marketingUrl: 'https://dev.kernalhq.com',
  dashboardUrl: 'https://dev.kernalhq.app',
  cognitoRegion: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_YJzqdR45H',
  cognitoClientId: '3g62u69geftrt3p1kj67f654i9', // AdminSpaClientId from CDK output
  // GA4 measurement ID is selected by hostname in AnalyticsService (prod vs non-prod),
  // because both dev and prod admin deploys use the production build configuration.
};
